import {
  GetString,
} from 'fluent-react';
import React from 'react';
import styled, {keyframes} from 'styled-components';
import { smallMediaQuery } from '../Grid';
import HelpTooltip from '../utilityBarItems/HelpTooltip';
import {
  primaryColor1,
} from '../Utils';
import {
  SlideAdvanceContainer,
  SlidePreviousContainer,
} from './SharedStyling';

//#region Styling
const bounceUp = keyframes`
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: rotate(180deg) translateY(0);
  }

  40% {
    transform: rotate(180deg) translateY(0.7rem);
  }

  60% {
    transform: rotate(180deg) translateY(0.3rem);
  }
`;

const bounceDown = keyframes`
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }

  40% {
    transform: translateY(0.7rem);
  }

  60% {
    transform: translateY(0.3rem);
  }
`;

const bounceDuration = '1'; // in seconds

const iconAspectRatio = 15 / 29; // from SVG's viewBox
const iconHeight = 1.75; // in rem
const iconHeightSmall = 1; // in rem
const IconContainer = styled.div`
  width: ${iconHeight * iconAspectRatio}rem;

  svg {
    line {
      fill: none;
      stroke-miterlimit: 10;
      stroke-width: 3;
      stroke: ${primaryColor1};
    }

    polygon {
      fill: ${primaryColor1};
    }
  }

  @media ${smallMediaQuery} {
    width: ${iconHeightSmall * iconAspectRatio}rem;
  }
`;
const IconContainerPrev = styled(IconContainer)`
  svg {
    transform: rotate(180deg);
  }
`;

const NextRoot = styled(SlideAdvanceContainer)`
  margin-bottom: 1.5rem;
  display: flex;
  align-items: flex-start;

  &:hover {
    svg {
      animation: ${bounceDown} ${bounceDuration}s ease-in-out infinite;
    }
  }
`;
const PrevRoot = styled(SlidePreviousContainer)`
  margin-top: 1.5rem;
  display: flex;
  align-items: flex-end;

  &:hover {
    svg {
      animation: ${bounceUp} ${bounceDuration}s ease-in-out infinite;
    }
  }

  @media ${smallMediaQuery} {
    margin-top: 0.7rem;
  }
`;
const AdvancerContainer = styled.div`
  display: flex;
  cursor: pointer;
  pointer-events: auto;
  position: relative;
  width: 100%;
`;
const Label = styled.div`
  color: ${primaryColor1};
  font-size: 1.125rem;
  line-height: 1.4;
  margin-left: 0.5rem;

  @media ${smallMediaQuery} {
    font-size: 0.8rem;
  }
`;
//#endregion

export enum Direction {
  Next,
  Previous,
}

interface Props {
  onClick: (e: React.MouseEvent) => void;
  children: string;
  direction: Direction;
  isHelpActive: boolean;
  helpTooltipIndex: number;
  getFluentString: GetString;
}

export default (props: Props) => {
  const {
    onClick, children, direction,
    helpTooltipIndex, isHelpActive,
    getFluentString,
  } = props;
  const Icon = direction === Direction.Next ? IconContainer : IconContainerPrev;
  const Root = direction === Direction.Next ? NextRoot : PrevRoot;
  const opacity  = direction === Direction.Next ? 1 : 0.5;
  return (
    <Root>
      <AdvancerContainer onClick={onClick}>
        <Icon
          style={{opacity}}
          dangerouslySetInnerHTML={{__html: require('./arrow.svg')}}
        />
        <Label
          style={{opacity}}
        >
          {children}
        </Label>
        <HelpTooltip
          index={helpTooltipIndex}
          term={getFluentString('help-tooltips-arrow-nav-title')}
          explanation={getFluentString('help-tooltips-arrow-nav-description')}
          isHelpActive={isHelpActive}
          styles={{}}
        />
      </AdvancerContainer>
    </Root>
  );
};
